import { Components, Theme } from '@mui/material'

// Handles hover over this + hover over a label wrapping it
const hoverSelector = (additionalSelector: string = '') =>
  `&${additionalSelector}:hover:not(.Mui-disabled), label:hover &${additionalSelector}:not(.Mui-disabled)`

export const MuiRadio: Components<Omit<Theme, 'components'>>['MuiRadio'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.futureTheme.border.strong,
      [hoverSelector()]: {
        color: theme.palette.futureTheme.border.strongest,
      },

      '&.Mui-checked': {
        color: theme.palette.futureTheme.fg.brand.default,
        [hoverSelector()]: {
          color: theme.palette.futureTheme.bg.brand.hover,
        },
      },
      '&.Mui-disabled': {
        opacity: 0.3,
      },
      '.Mui-error &': {
        color: theme.palette.futureTheme.border.danger.strong,
      },
      ['.Mui-error &:hover:not(.Mui-disabled), .Mui-error label:hover &:not(.Mui-disabled)']: {
        color: theme.palette.futureTheme.border.danger.strongest,
      },
    }),
  },
  variants: [
    {
      props: {
        'data-is-ai-prefilled': true,
      },
      style: ({ theme }) => ({
        '&.Mui-checked:not(.Mui-disabled)': {
          color: theme.palette.futureTheme.fg.ai.default,
        },
        [hoverSelector('.Mui-checked')]: {
          color: theme.palette.futureTheme.fg.ai.strongest,
        },
      }),
    },
  ],
}
